import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { HEIGHT_PER_HOUR } from "ScheduleConstants";

class TimeSlot extends Component {
  renderSlots() {
    let { sessionScreenZoom } = this.props;
    let heighPerHour = !_.isEmpty(sessionScreenZoom)
      ? sessionScreenZoom.height
      : HEIGHT_PER_HOUR;
    var style = { height: heighPerHour };

    if (this.props.timeSlots) {
      var items = this.props.timeSlots.map((slot, index) => {
        var time = slot;
        if (slot > 12) {
          time = slot - 12;
        }
        var timeStr = `${time.toString().padStart(2, "0")} ${
          slot >= 12 ? "PM" : "AM"
        }`;

        // This if condition is added on to show if session starts with midnignt 00 AM, it will display 12 AM as UI required
        if (slot === 0) {
          timeStr = `12 AM`;
        }
        if (slot === 24) {
          timeStr = `11:59 PM`;
        }

        return (
          <li
            key={index}
            className="list-group-item time-slot-li"
            style={slot === 24 ? {} : style}
          >
            {timeStr}
          </li>
        );
      });

      return items;
    }
  }

  // <ul className="list-group" style={{marginTop:'-2990px'}}>
  render() {
    return (
      <ul className="list-group">
        {/*<li className="list-group-item time-slot-li">&nbsp;</li>*/}
        {this.props.isFetching ? <div /> : this.renderSlots()}
      </ul>
    );
  }
}

function mapStateToProps(state) {
  /*var times=[];

  var tracks=state.selectedScheduleDate.ScheduleDateToScheduletracks;
  var sessions=state.scheduleData.payload.session_by_eventid;

  var startHour=6;
  var endHour=18;

  if(tracks && sessions){
    tracks.map((track) =>{
      var trackSessions=sessions.filter((session)=>(session.scheduletrackid===track.scheduletrackid));
      trackSessions.map((session) => {
        var nowStart=new Date(session.starttime);
        var startDate=new Date(nowStart.getTime() - nowStart.getTimezoneOffset() * 60000);

        var startHour = startDate.getUTCHours();

        var nowEnd=new Date(session.endtime);
        var endDate=new Date(nowEnd.getTime() - nowEnd.getTimezoneOffset() * 60000);

        var endHour = endDate.getUTCHours();

        times.push({'hour':startHour});
        times.push({'hour':endHour});

        times = _.sortBy(times, 'hour', (n) => Math.sin(n));
      });
    });

    if(times.length>0){
      startHour=times[0].hour;
      endHour=times[times.length-1].hour;

      if(endHour<18){
        endHour=19;
      }
    }
  }*/

  // var dateTimes = {};
  // var startTimes = [];
  // var hour = "";
  // var minTime = 0;
  // var maxTime = 0;
  // var minStartTime = (array, date) => {
  //   array.map((item) => {
  //     var onlyDate = item.starttime.substring(0, 10);
  //     let checkEndHr = parseInt(item.endtime.substring(11, 13));
  //     let checkEndMin = parseInt(item.endtime.substring(14, 16));
  //     let startHr = parseInt(item.starttime.substring(11, 13));
  //     let endHr = checkEndMin > 0 ? checkEndHr + 1 : checkEndHr;
  //     if (dateTimes[onlyDate]) {
  //       if (dateTimes[onlyDate].startHr > startHr) {
  //         dateTimes[onlyDate]["startHr"] = startHr;
  //       }
  //       if (dateTimes[onlyDate].endHr < endHr) {
  //         dateTimes[onlyDate]["endHr"] = endHr;
  //       }
  //     } else {
  //       dateTimes[onlyDate] = { startHr: startHr, endHr: endHr };
  //     }
  //     /* if(item.starttime.substring(0,10)==onlyDate){
  //       hour = item.starttime.substring(11,13);
  //       startTimes.push(hour);
  //     }*/
  //   });
  //   // console.log("dateTimes : ", dateTimes);
  //   // console.log(`Time range for date ${date} is : ${minTime} - ${maxTime}`);
  //   // console.log("lowest time is : ", Math.min.apply(null, startTimes));
  //   if (date in dateTimes) {
  //     minTime = dateTimes[date].startHr;
  //     maxTime = dateTimes[date].endHr;
  //   }
  // };
  // // console.log("state is : ", state.scheduleData.payload.session_by_eventid);
  // var dateClickedOn = state.selectedScheduleDate.scheduledate;
  // // console.log("selected date : ", dateClickedOn);
  // if (state.scheduleData.payload.session_by_eventid) {
  //   // Get the Time range
  //   minStartTime(state.scheduleData.payload.session_by_eventid, dateClickedOn);
  //   var slots = [];
  //   if (maxTime > 0) {
  //     for (var hour = minTime; hour <= maxTime; hour++) {
  //       slots.push(hour);
  //     }
  //   }
  //   return {
  //     isFetching: state.scheduleData.isFetching,
  //     timeSlots: slots,
  //     sessionScreenZoom: state.sessionScreenZoom,
  //   };
  // } else {
  //   return {
  //     isFetching: state.scheduleData.isFetching,
  //     sessionScreenZoom: state.sessionScreenZoom,
  //   };
  // }

  return {
    isFetching: state.scheduleData.isFetching,
    sessionScreenZoom: state.sessionScreenZoom,
  };
}

export default connect(mapStateToProps)(TimeSlot);
